export const handleExternalLink = (url: string) =>
  url.startsWith('http://') || url.startsWith('https://')
    ? url
    : `https://${url}`;

export const getInitials = (name?: string) => {
  if (!name) return '';
  const parts = name.split(' ');
  const firstPart = parts[0];
  const lastPart = parts[parts.length - 1];

  return parts.length < 2 ? firstPart[0] : `${firstPart[0]}${lastPart[0]}`;
};

export const removeCompanyFromName = (value: string) =>
  value.replace(/\s*\(.*?\)$/, '').trim();

export const capitalizeWords = (value: string) =>
  value.replace(/\b\w/g, char => char.toUpperCase());

export const extractNameFromEmail = (email?: string) => {
  if (!email) return '';
  const name = email.split('@')[0];

  return name
    ? capitalizeWords(removeCompanyFromName(name).replace('.', ' '))
    : '';
};

export const snakeToTitle = (str: string) =>
  str.split('_').map(capitalizeWords).join(' ');

export const firstLetterUppercase = (text: string = '') =>
  text ? text[0].toUpperCase() + text.slice(1) : '';

export const cleanString = (val?: string) =>
  val && val.trim().length > 0 ? val : null;

export const numberToOrdinal = (number: number) => {
  const suffix = ['th', 'st', 'nd', 'rd'];
  const v = number % 100;

  return `${number}'${suffix[(v - 20) % 10] || suffix[v] || suffix[0]}`;
};
